import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './scene.styles'
import Actions from './actions/actions.container'
import WorkSelect from './work-select/work-select.container'
import Pagination from './pagination/pagination.container'
import Media from './media/media.container'
import Discussion from './discussion/discussion.container'
import Spinner from 'pobble-components/dist/spinner'

const Scene = ({ classes, pending }) => {
  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        <Fragment>
          <div className={classes.page}>
            {pending && <Spinner className={classes.spinner} />}
            {!pending && (
              <Fragment>
                <div className={classes.head}>
                  <WorkSelect />
                  <Pagination />
                </div>
                <Media />
              </Fragment>
            )}
          </div>
          <Discussion />
        </Fragment>
      </div>
      <Actions />
    </div>
  )
}

export default injectSheet(styles)(Scene)
